import PickerListMail from "./PickerListMail";
import { usePicker } from "contexts/pickerContext/pickerContext.ts";
import {
  filterPickerProjects,
  sliceCurrentPage,
} from "contexts/pickerContext/helpers";
import useMediaQueries from "hooks/useMediaQueries";
import useInboxQueryParams from "hooks/useInboxQueryParams";
import { useAppSelector } from "store/hooks";
import {
  selectCurrentPage,
  selectIsSortAsc,
  selectItemsPerPage,
  selectPickerSearchParams,
} from "store/selectors/inboxSelectors";

//@ts-ignore
import styles from "./styles.module.scss";

const PickerMailsContainer = () => {
  const { getPickerMailList } = usePicker();
  const { desktopCondition } = useMediaQueries();
  const { getQueryParam } = useInboxQueryParams();
  const isSortAsc = useAppSelector(selectIsSortAsc);
  const currPageNum = useAppSelector(selectCurrentPage);
  const itemsPerPage = useAppSelector(selectItemsPerPage);
  const pickerSearchParams = useAppSelector(selectPickerSearchParams);

  return (
    <>
      <ul className={styles.listWrapper}>
        {getPickerMailList() &&
          filterPickerProjects(
            getPickerMailList(),
            getQueryParam("q") || "",
            pickerSearchParams.ps || []
          )
            .slice()
            .sort((a, b) => {
              const dateA = new Date(a.CreationDate).getTime();
              const dateB = new Date(b.CreationDate).getTime();
              return isSortAsc ? dateA - dateB : dateB - dateA;
            })
            .slice(
              ...sliceCurrentPage(currPageNum, desktopCondition, itemsPerPage)
            )
            .map((project, index) => (
              <PickerListMail
                item={project}
                key={project.PickerProjectID}
                index={index}
              />
            ))}
      </ul>
    </>
  );
};

export default PickerMailsContainer;
